import React, { useState } from 'react';
import { NavbarBrand } from './components/NavbarBrand/NavbarBrand';
import { NavbarMenu } from './components/NavbarMenu/NavbarMenu';
import { NavbarActions } from './components/NavbarActions/NavbarActions';
import { NavbarMobileMenu } from './components/NavbarMobileMenu/NavbarMobileMenu';
import './Navbar.css';

export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="navbar-container">
      <div className="navbar-container__inner">
        <NavbarBrand />
        <NavbarMenu />
        <NavbarActions
          mobileMenuOpen={mobileMenuOpen}
          onToggleMobileMenu={() => setMobileMenuOpen((prev) => !prev)}
        />
      </div>

      <NavbarMobileMenu
        isOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />
    </header>
  );
}
